import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'hip-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  @Input()
  public percentage = 0;
}
